import React from 'react'
import { Upload, UploadProps, Icon } from 'antd'

class UploadFile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            status: 'waiting',
            fileList: []
        }
    }

    draggerProps: UploadProps = {
        showUploadList: false,
        customRequest: async request => {
            const { bucket = 'clients' } = this.props
            const newFile = request.file
            const formData = new FormData()
            await formData.append('file', newFile)
            const fileType = 'cancellation_request'

            this.props.setFileData({ formData, details: { bucket, fileType, uniq: 'true' } })
        },

        beforeUpload: file => {
            // const { fileList } = this.state
            this.setState({ fileList: [file] })
        }
    }

    render() {
        const { fileList } = this.state
        return (
            <Upload.Dragger {...this.draggerProps}>
                <div>
                    {fileList.length > 0 && <span>{fileList[0].name}</span>}

                    {fileList.length === 0 && (
                        <>
                            <Icon type="cloud-upload" />
                            <span>{' גרור לכאן קובץ להעלאה או לחץ לבחירת קובץ מתוך תיקיה'}</span>
                        </>
                    )}
                </div>
            </Upload.Dragger>
        )
    }
}

export default UploadFile
